//
//
//
//
//
//
//
//
import AList from 'ant-design-vue/es/list';
import AListItem from 'ant-design-vue/es/list/Item';
export default {
  name: "Article",
  components: {
    AList: AList,
    AListItem: AListItem
  }
};